var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdgeCurvDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 81,
    viewBox: "0 0 800 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.0514V55.8023C175.38 33.6465 436.307 8.00473 800 60.2457V54.0457C605.923 14.6306 355.33 -5.90308 0 28.0514Z",
    fill: "#DADADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.163574 81V52.3731C322.792 15.798 595.256 24.2941 800 60V68.3963C451.751 23.4785 152.989 59.4623 0.163574 81Z",
    fill: "#88219F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.327087 32.5614C335.123 -6.10526 564.363 14.2456 800 58V-3.8147e-06L0.327087 -3.8147e-06V32.5614Z",
    fill: "#88219F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeCurvDown);
export default __webpack_public_path__ + "static/media/edgeCurv-Down.6dfc122df821326d15fa18e93e18ac40.svg";
export { ForwardRef as ReactComponent };